import {
  UserCheckIcon,
  UserMinusIcon,
  ClipboardListIcon,
  SparklesIcon,
  type LucideIcon,
} from 'lucide-react';
import { Chip } from '@/components/Chip';
import { Tone } from '@gokrew/models/ui.types';
import type { TaskSource, TaskFlowType } from '@gokrew/models/tasks';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';

const SOURCE_CONFIG: Record<
  'onboarding' | 'offboarding' | 'automation' | 'company',
  { tone: Tone; Icon: LucideIcon; labelKey: string }
> = {
  onboarding: {
    tone: Tone.SOFT_BLUE,
    Icon: UserCheckIcon,
    labelKey: 'tasks.source.onboarding',
  },
  offboarding: {
    tone: Tone.ACCENT,
    Icon: UserMinusIcon,
    labelKey: 'tasks.source.offboarding',
  },
  automation: {
    tone: Tone.WARNING,
    Icon: SparklesIcon,
    labelKey: 'tasks.source.automation',
  },
  company: {
    tone: Tone.NEUTRAL,
    Icon: ClipboardListIcon,
    labelKey: 'tasks.source.company',
  },
};

interface TaskSourceTagProps {
  source: TaskSource;
  flowType?: TaskFlowType | null;
}

export function TaskSourceTag({ source, flowType }: TaskSourceTagProps) {
  const { t } = useTranslation(TranslationNS.LibsCommon);
  const key = source === 'flow' && flowType ? flowType : 'company';
  const config = SOURCE_CONFIG[key];
  const Icon = config.Icon;

  return (
    <Chip type={config.tone} size="xs" className="inline-flex items-center gap-1">
      <Icon size={10} />
      {t(config.labelKey)}
    </Chip>
  );
}
